import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reading-english-type',
  templateUrl: './reading-english-type.component.html',
  styleUrls: ['./reading-english-type.component.scss']
})
export class ReadingEnglishTypeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
